export default {
  title: 'Knowledge Hub',
  title_short: 'Knowledge Hub',
  // description:
  //   'You can configure videos and learning paths that needs to shown in the video academy along with analytics, public/private access, theme and text copy. ',
  description:
    'Organize your help videos, instructional guides, and product tours into a self-service Knowledge Hub.',
  button: {
    disable: 'Disable Academy',
    enable: 'Enable Knowledge Hub',
    email_activity: 'Email user activity',
  },
  builder: {
    title: 'Builder',
    desc: 'Build and manage your Knowledge Hub from here.'
  },
  tab: {
    settings: 'Security',
    analytics: 'Analytics',
    custom_domain: 'Custom Domain',
    theme: 'Brand Styles',
    guide_theme: 'Guide Theme',
    copy: 'General',
    content: 'Content',
  },
  auth_type: {
    label: 'Authentication',
    desc: 'Configure authentication settings for your Knowledge Hub.',
    public: 'Public Access',
    public_desc: 'Anyone with the link can access the Knowledge Hub. No authentication needed for login.',
    private: 'Private Access',
    private_desc: 'Only authenticated customers can access the Knowledge Hub.',
    sso: "Use your application's authentication (SSO)",
    sso_documentation_link:
      "Check this <a target='_blank' href='https://help.trainn.co/share/dabTAiuVyypmrtWwGmDL9w'>documentation</a> on how to integrate SSO with knowledge Hub.",
    sso_desc:
      'Allows members to sign in to your Knowledge Hub using your application authentication',
    train_login: 'Use Email Authentication',
    train_login_desc:
      'Allows members to sign in to your Knowledge Hub using their Email & Password',
    train_auth_customer_signup: 'Allow anyone to sign up',
    train_auth_customer_signup_desc:
      'Uncheck to restrict the access only to existing customers',
    login_url: 'Login URL',
    login_url_desc:
      'URL to which the user needs to be redirected for authentication.',
    saml: 'Single Sign-On SAML',
    saml_documentation_link:
      "Check this <a target='_blank' href='https://help.trainn.co/share/GnT3UWKML0YoHBOXQtirIA'>documentation</a> on how to integrate SSO SAML with Knowledge Hub.",
    saml_login_url: 'Login URL',
    saml_login_url_desc: 'Users will be redirected to this URL to login.',
    saml_certificate: 'SAML Certificate',
    saml_certificate_desc:
      'SAML X.509 certificate to authenticate with your Identity Provider',
    logout_url: 'Remote Logout URL (optional)',
    logout_url_desc:
      'Users will be redirected to this URL when they logout from Hub',
  },
  general_settings: 'Settings',
  goto_url: 'Enter the URL that customers should be taken to when they click your logo in the Knowledge Hub header.',
  allow_crawling: 'Allow google to crawl all the videos',
  private_crawling: 'Allow google to crawl login page',
  markdown_for_llms:
    "Allow AI/LLMs to read hub content. <a target='_blank' rel='noopener noreferrer' href='https://help.trainn.co/UzQH08LL5y4-knowledge-hub-management/wlThUdYBWmE-allow-ai-llms-to-read-hub-content' class='t-link t-fs--body t-td--border'>Learn more</a>",
  analytics: {
    allow_ga_label: 'Enable Google Analytics Tracking',
    allow_ga_desc:
      'Connect with Google Analytics to track user behavior, identify popular articles and spot content gaps.',
    tracking_code_label: 'Google Analytics tracking code - Deprecated',
    measurement_code_label: 'GA-4 Measurement Id',
    tracking_code_desc: 'Copy and paste your Google Analytics tracking code',
    measurement_code_desc:
      "<a target='_blank' href='https://support.google.com/analytics/answer/12270356?hl=en'>Where to find your GA-4 Measurement ID?</a>",
    cross_origin_tracking_label: 'Enable Cross-origin Tracking',
    cross_origin_tracking_desc: 'Track user activity across your domains by linking their sessions for unified analytics.',
    origin_ids_label: 'Origin IDs',
    origin_ids_desc: 'Use comma to separate domain names',
    title: 'Analytics',
    desc: `Get a summary of metrics to measure the performance of your Knowledge Hub.`,
    total_views: 'Total Views',
    uniq_views: 'Unique Views',
    uniq_visitors: 'Unique Visitors',
    avg_engagement_time: 'Avg Engagement Time',
    total_engagement_time: "Total Engagment Time",
    engagement_time: 'Total Training Time Saved',
    content_views: 'Total Content Views',
    video_views: 'Video',
    guide_views: 'Guide',
    article_views: 'Article',
    document_views: 'Document',
    learners: 'Total Learners',
    content_title: 'Title',
    views: 'Views',
    untitled: 'Untitled',
    top_videos: 'Top Videos',
    top_guides: 'Top Guides',
    top_articles: 'Top Articles',
    top_documents: 'Top Documents',
    top_searches: 'Top Searches',
    keyword: 'Search Terms',
    result: 'Search count',
    searches_chart: 'Search Performance',
    number_of_searches: 'Search count',
    ctr_chart: 'Clicks',
    empty_content: `There’s no content available yet.`,
    loading: 'Loading...',
    ctr: 'CTR',
    view_all: 'View all ',
    all_videos: 'All Videos',
    all_videos_desc: 'See how each of your videos is performing with views and engagement metrics.',
    all_guides: 'All Guides',
    all_guides_desc: 'See how each of your guides is performing with views and engagement metrics.',
    all_articles: 'All Articles',
    all_articles_desc: 'See how each of your articles is performing with views and engagement metrics.',
    all_documents: 'All Documents',
    all_documents_desc: 'See how each of your documents is performing with views and engagement metrics.',
    search_date_cta: 'This data is available only from Nov 25, 2025.',
    tool_tip: {
      total_views: 'Total number of times your help content has been viewed',
      uniq_visitors: 'Number of individual users who viewed your content',
      avg_engagement_time: 'Average time a user spends with your content',
      total_engagement_time: 'Total time a user spends with your content',
      engagement_time: 'Support hours saved by users finding answers in your content',
      content_views: 'Total views over time for your content to see what formats your users prefer',
      learners: 'Total number of learners actively engaging with your help content on a daily basis',
      top_searches: 'Most searched terms and their click-through rate (% of searches that resulted in a click)',
      searches_chart: 'Track search volume and clicks on a daily basis'
    },
  },
  theme: {
    primary_color: 'Primary Color',
    placeholder: '#FFFFFF',
    favicon: 'Upload your favicon',
    faviconDescription: 'It will be displayed in browser tabs, bookmarks, and address bar. Recommended size is 32 x 32 pixels.',
    bannerImage: 'Upload your banner image',
    bannerDescription:
      "Recommended size is 1440 x 780 pixels. Download banner images for free from from <a href='https://unsplash.com/' target='_blank'>Unsplash.</a>",
    logo: 'Upload your logo',
    logoDescription: 'Recommended width is 100px minimum to 1400px maximum.',
  },
  copy: {
    title: 'Title',
    title_placeholder: `{workspace_name} Knowledge Hub`,
    description: 'Description',
    login_description: 'Login Page Description',
    desc_placeholder:
      'A description of your workspace. Example, One stop Knowledge Hub to learn everything about {workspace_name}',
    login_desc_placeholder:
      "We have created videos for you on how to use our product. Login to view these videos and understand our product's capabilities.",
  },
  content: {
    desc: 'Add, remove, and rearrange content that needs to be displayed in your hub.',
    collection_title: 'Collections',
    collection_desc:
      'Add, remove, and rearrange collections that needs to be displayed in your hub.',
    recommended_title: 'Recommended Content',
    recommended_desc: "Add videos and guides you want to recommend to your user.",
    add_collection: 'Add Collection',
    available_collections: 'Available collections',
    add_videos: 'Add Video',
    add_guide: 'Add Guide',
    add_article: 'Add Article',
    add_document: 'Add Document',
    add_content: 'Add Content',
    availabe_videos: 'Available Videos',
    advanced_mode: {
      desc: 'Group collections, manage content and much more.',
      cta: 'Switch to Advanced mode',
      learner_group_cta: ' Switch to Category Mode ',
      learner_group_desc: 'Group collections into high-level categories.'
    },
    categories: {
      title: 'Categories',
      // desc:
      //   'Add, remove, and rearrange learning paths and group them into categories to be displayed in the academy',,
      desc: 'Add collections of a topic into a category. You can add multiple categories to your Knowledge Hub.',
      add: {
        title: 'Add Category',
        label: 'Category Name',
        placeholder: 'Default Category',
      },
      edit: {
        title: 'Edit Category',
        label: 'Category Name',
      },
      collections: 'Total number of collections',
      empty:
        'No collections added yet. Add, remove, and rearrange collections that has to be displayed under this category in the hub.',
      delete: {
        title: 'Are you sure you want to delete this category?',
        desc: 'On deleting, this category will be removed permanently and cannot be retrieved back.',
      },
      remove: {
        title: 'Are you sure you want to remove this collection?',
        desc: 'On removing, this collection will be removed permanently from the current category',
      },
      recommended_remove: {
        title: 'Are you sure you want to remove this content?',
        desc: 'On removing, this content will be removed permanently from the recommended content list.',
      }
    },
  },
  invalid_url_format: 'Please enter a valid url',
  portal_url: 'Your portal url',
  trigger_email_activity: 'User activity will be sent to your mail',
  category_flow: {
    title: 'Enable Category Flow',
    desc: 'Enable this setting to allow users to view category flow in the Knowledge Hub.',
  },
};
